import { createFileRoute } from '@tanstack/react-router';

import { SynthesisPage } from '@dashboard';

export const Route = createFileRoute('/_app/synthesis')({
  component: SynthesisPage,
});
